/* Ishira homepage helpers (HOME-001): metal swatches on cards, metal trio (mobile), carousel arrows. No dependencies. */
(function () {
  'use strict';
  function qsa(el, s) { return Array.prototype.slice.call(el.querySelectorAll(s)); }

  function initSwatches(root) {
    qsa(root, '[data-ish-sw]').forEach(function (group) {
      if (group._ish) return; group._ish = true;
      var target = group.closest('[data-ish-sw-scope]');
      var img = target && target.querySelector('img.main');
      var link = target && target.querySelector('[data-ish-sw-link]');
      qsa(group, 'button').forEach(function (b) {
        b.addEventListener('click', function () {
          qsa(group, 'button').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          if (img && b.dataset.src) {
            img.src = b.dataset.src;
            if (b.dataset.srcset) img.srcset = b.dataset.srcset; else img.removeAttribute('srcset');
            if (b.dataset.alt) img.alt = b.dataset.alt;
            var alt = target.querySelector('img.alt'); if (alt) alt.style.display = 'none';
          }
          if (link && b.dataset.href) link.href = b.dataset.href;
        });
      });
    });
  }

  function initArrows(root) {
    qsa(root, '[data-ish-carousel]').forEach(function (c) {
      if (c._ish) return; c._ish = true;
      var track = c.querySelector('[data-ish-track]');
      qsa(c, '[data-ish-dir]').forEach(function (b) {
        b.addEventListener('click', function () {
          var card = track.firstElementChild; var step = card ? card.getBoundingClientRect().width + 24 : 300;
          track.scrollBy({ left: step * parseInt(b.dataset.ishDir, 10), behavior: 'smooth' });
        });
      });
    });
  }

  function init(e) { var root = (e && e.target && e.target.querySelectorAll) ? e.target : document; initSwatches(root); initArrows(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('ishira:refresh', function () { init(); });
})();